<div class="lock-container" *ngIf="showCreateMimicBanner">
  <div class="notification-message">
    {{ 'mimic.page.create-mimic.banner.text' | translate }}
  </div>
  <div
    class="notification-button"
    data-cy="mimics-create-button-notification"
    (click)="createNewMimic()">
    {{ 'mimic.page.create-mimic.banner.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showRequestAccess">
  <mat-icon svgIcon="lock-profile" data-cy="mimics-no-access-icon" />
  <div class="notification-message" data-cy="mimics-no-access-message">
    {{ 'mimic.page.locked.notification.request.message' | translate }}
  </div>

  <div
    class="notification-button"
    data-cy="mimics-no-access-button"
    (click)="requestVesselAccess()">
    {{ 'mimic.page.locked.notification.request.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRequested">
  <mat-icon svgIcon="lock-profile" data-cy="mimics-req-access-pending-icon" />
  <div class="notification-message" data-cy="mimics-req-access-pending-message">
    {{ 'mimic.page.locked.notification.requested.message' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessAccepted">
  <mat-icon svgIcon="lock-clock" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.accepted.message' | translate: { owner: ownerName } }}
  </div>
  <div class="notification-button" (click)="startEdit()">
    {{ 'mimic.page.locked.notification.accepted.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRemoved">
  <mat-icon svgIcon="lock" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.removed.message' | translate }}
  </div>
  <div class="notification-button" (click)="showAccessRemovedDialog()">
    {{ 'mimic.page.locked.notification.removed.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showAccessRejected">
  <mat-icon svgIcon="lock" />
  <div class="notification-message" data-cy="mimics-access-rejected-message">
    {{ 'mimic.page.locked.notification.rejected.message' | translate }}
  </div>
    <div 
        class="notification-button" 
        data-cy="mimics-access-rejected-button" 
        (click)="closeRejectedMessage()">
        {{ 'mimic.page.locked.notification.rejected.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showVesselInReview">
  <mat-icon svgIcon="pending-approval" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.pending.message' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="showVesselApproved">
  <mat-icon svgIcon="spaceship" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.approved.message' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="isVesselUnassigned">
  <mat-icon svgIcon="unlocked" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.unassigned-vessel.message' | translate }}
  </div>
  <div class="notification-button" (click)="claimOwnership()">
    {{ 'mimic.page.locked.notification.claim.button' | translate }}
  </div>
</div>

<div class="lock-container" *ngIf="vesselNeedsNewVersion">
  <mat-icon svgIcon="no-file" />
  <div class="notification-message">
    {{ 'mimic.page.locked.notification.start-new-version.message' | translate }}
  </div>
  <div class="notification-button" (click)="goBackToVessel()">
    {{ 'mimic.page.locked.notification.go-back-vessel.button' | translate }}
  </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner></app-loading-spinner></ng-container>

<app-confirmation-window
  #claimOwnershipConfirmationDialog
  [mainLabel]="'vessel.page.message.ownership.claim.dialog.title'"
  [subLabel]="'vessel.page.message.ownership.claim.dialog.message'"
  [discardLabel]="'vessel.page.message.ownership.claim.dialog.cancel'"
  [saveLabel]="'vessel.page.message.ownership.claim.dialog.claim'"
  [allButtonsLeft]="true"></app-confirmation-window>
